export class NativeStreamTransformConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "NativeStreamConnectionKind",
            "format": ""
        },
        {
            "name": "apiKeySecret",
            "baseName": "apiKeySecret",
            "type": "SecretRef",
            "format": ""
        },
        {
            "name": "timeoutMs",
            "baseName": "timeoutMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "maxRetries",
            "baseName": "maxRetries",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "maxInFlight",
            "baseName": "maxInFlight",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "maxRequestsPerSecond",
            "baseName": "maxRequestsPerSecond",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "cacheBytes",
            "baseName": "cacheBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "http",
            "baseName": "http",
            "type": "NativeStreamHttpConnection",
            "format": ""
        },
        {
            "name": "chat",
            "baseName": "chat",
            "type": "NativeStreamChatConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformConnection.attributeTypeMap;
    }
    constructor() {
    }
}
